<template>
  <v-container class="grey lighten-5">
    <v-card :elevation="4" class="pa-2">
      <v-row justify="center">
        <v-col class="mb-12">
          <v-radio-group label="Traer registros fecha hoy" v-model="radioGroup4">
            <v-radio name="active" label="Si" :value="0" @change="getPorFechahoy"></v-radio>
            <v-radio name="active" label="No" :value="1" @change="getPorFechahoy"></v-radio>
          </v-radio-group>

          <div v-if="singleFecha">
            <v-col>
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="date"
                    label="Seleccione fecha Desde"
                    prepend-icon="mdi-calendar-account"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="date" no-title scrollable locale="es">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                  <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                </v-date-picker>
              </v-menu>

              <v-menu
                ref="menu2"
                v-model="menu2"
                :close-on-content-click="false"
                :return-value.sync="date2"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="date2"
                    label="Seleccione fecha Hasta"
                    prepend-icon="mdi-calendar-account"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="date2" no-title scrollable locale="es">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu2 = false">Cancel</v-btn>
                  <v-btn text color="primary" @click="$refs.menu2.save(date2)">OK</v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
          </div>

          <v-select
            v-model="select0"
            :items="empresas"
            item-text="nombre"
            item-value="id"
            label="Seleccione sede"
            required
            @change="getEmpresadetails"
          ></v-select>

          <v-checkbox
            v-model="traeregistrosporusuario"
            label="Traer registros por usuario"
            value="none"
            @change="getPorUsuario"
          ></v-checkbox>

          <div v-if="traeregistrosporusuario">
            <v-data-table
              v-model="selected4"
              :headers="headers4"
              :items="tabla4"
              :single-select="singleSelect"
              item-key="id"
              show-select
              class="elevation-1"
              @click:row="getRecordSelected"
            ></v-data-table>

            <div class="text-center pt-2">
              <v-pagination v-model="page4" :length="pageCount4" @input="getPorUsuario"></v-pagination>

              <br />
              <br />

              <v-btn @click="selectedItems" block color="primary">Eliminar usuario</v-btn>
              <br />
            </div>
          </div>

          <v-btn @click="exportarRegistros" block color="primary">Exportar registros a excel</v-btn>
          <br />
          <v-btn @click="getRegistros" block color="primary">Traer registros</v-btn>
        </v-col>

        <div class="text-center">
          <v-progress-circular
            v-if="statusLoader"
            :size="70"
            :width="7"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>
      </v-row>
    </v-card>

    <v-row justify="center">
      <v-col class="mb-6">
        <div class="text-center">
          <h2>ENTRADAS</h2>
          <br />
        </div>

        <v-card :elevation="4" class="pa-2">
          <v-card>
            <v-data-table
              v-model="selected"
              :headers="headers2"
              :items="tabla2"
              :single-select="singleSelect"
              item-key="id"
              class="elevation-1"
            ></v-data-table>

            <div class="text-center pt-2">
              <v-pagination
                v-model="page"
                :length="pageCount"
                @input="getRegistrosENtradaspaginadas"
              ></v-pagination>

              <br />
              <br />
            </div>
          </v-card>
        </v-card>
      </v-col>

      <v-col class="mb-6">
        <div class="text-center">
          <h2>SALIDAS</h2>
          <br />
        </div>

        <v-card :elevation="4" class="pa-2">
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="tabla"
            :single-select="singleSelect"
            item-key="id"
            class="elevation-1"
          ></v-data-table>

          <div class="text-center pt-2">
            <v-pagination
              v-model="page2"
              :length="pageCount2"
              @input="getRegistrosSalidaspaginadas"
            ></v-pagination>

            <br />
            <br />
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Reactivacion de usuarios</v-card-title>

        <v-card-text>Desea reactivar el usuario {{nombre}} de nuevo ?</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="dialog = false">Cancelar</v-btn>

          <v-btn color="green darken-1" text @click="activateUserAgain">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card :elevation="4" class="pa-2">
      <v-row justify="center">
        <v-col class="mb-12">
          <div class="text-center">
            <h2>TOTAL TIEMPO LABORADO</h2>
            <br />
          </div>

          <v-card>
            <v-data-table
              v-model="selected3"
              :headers="headers3"
              :items="tabla3"
              :single-select="singleSelect3"
              item-key="id"
              class="elevation-1"
            ></v-data-table>

            <div class="text-center pt-2">
              <v-pagination v-model="page3" :length="pageCount3" @input="getTotaltiempoLaborado"></v-pagination>

              <br />
              <br />
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>


<script>
import axios from "axios";
import { actionStore } from "./CheckerLocalStorage";
import Tabla from "./Tabla";

export default {
  components: {
    Tabla
  },

  data: vm => ({
    date2: new Date().toISOString().substr(0, 10),

    singleFecha: false,
    singleUsuario: false,
    radioGroup4: 0,
    radioGroup5: 0,
    dialog: false,
    date: new Date().toISOString().substr(0, 10),
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    menu1: false,
    menu2: false,
    e4: null,
    dropdown_font: ["Arial", "Calibri", "Courier", "Verdana"],
    perfiles: [{ id: 1, nombrePerfilCargo: "one" }],
    cargoNombre: [{ id: 1, nombrePerfilCargo: "one" }],
    fecha: "",
    empresas: [{ id: 1, nombrePerfilCargo: "one" }],
    select0: null,
    select1: null,
    select2: null,
    select3: null,
    cedula: "",
    nombre: "",
    pagination: "",
    statusFailure: false,
    statusEmpty: false,
    statusCreated: false,
    search: "",
    selected: [],
    selected2: [],
    selected3: [],
    selected4: [],
    singleSelect: true,
    singleSelect2: true,
    singleSelect3: true,
    empresaSelected: {},
    statusLoader: false,
    menu: false,
    traeregistrosporusuario: false,

    hora: "",
    url1: "",

    //*******TABLE PAGINATION */
    page4: 0,
    pageCount4: 0,

    headers4: [
      {
        text: "ID",
        align: "left",
        sortable: false,
        value: "id"
      },
      { text: "PERFIL", value: "perfil" },
      { text: "CARGO", value: "cargo" },
      { text: "CEDULA", value: "cedula" },
      { text: "NOMBRE", value: "nombre" }
    ],
    tabla4: [],

    //*******TABLE PAGINATION */

    //*******TABLE PAGINATION */
    page: 0,
    pageCount: 0,
    itemsPerPage: 10,
    headers: [
      { text: "Sede_Emision", value: "sedeemision" },
      { text: "NombreUsuario", value: "nombreusuario" },
      { text: "Cedula", value: "cedula" },
      { text: "Cargo", value: "nombrecargo" },
      { text: "Perfil", value: "nombreperfil" },
      { text: "Fecha", value: "fechasola" },
      { text: "Fecha-hora", value: "fecha" }
    ],
    tabla: [],

    //*******TABLE PAGINATION */

    //*******TABLE PAGINATION */
    page2: 0,
    pageCount2: 0,
    itemsPerPage2: 10,
    headers2: [
      { text: "Sede_Emision", value: "sedeemision" },
      { text: "NombreUsuario", value: "nombreusuario" },
      { text: "Cedula", value: "cedula" },
      { text: "Cargo", value: "nombrecargo" },
      { text: "Perfil", value: "nombreperfil" },
      { text: "Fecha", value: "fechasola" },
      { text: "Fecha-hora", value: "fecha" }
    ],
    tabla2: [],

    //*******TABLE PAGINATION */

    //*******TABLE PAGINATION */
    page3: 0,
    pageCount3: 0,
    itemsPerPage3: 10,
    headers3: [
      { text: "NombreUsuario", value: "nombre" },
      { text: "Cedula", value: "cedula" },
      { text: "Cargo", value: "cargonombre" },
      { text: "Perfil", value: "nombreperfil" },
      { text: "Total_dias", value: "totaldias" },
      { text: "Total_horas", value: "totalhoras" },
      { text: "Total_minutos", value: "totalminutos" },
      { text: "Total_segundos", value: "totalsegundos" }
    ],
    tabla3: []

    //*******TABLE PAGINATION */
  }),

  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    msg() {
      const selectedRow = this.selected[0];
      console.log(selectedRow);
    }
  },

  watch: {
    date() {
      this.dateFormatted = this.formatDate(this.date);
      this.fecha = "Fecha seleccionada: " + this.dateFormatted;
    },
    e4() {
      this.hora = "Hora seleccionada: " + this.e4;
      console.log("it has cahnged.." + this.e4);
    }
  },

  beforeMount() {
    console.log("URL .." + this.url1);
  },

  mounted() {
    let that = this;

    axios
      .get(
        actionStore.methods.getInfoEmpresa().urlServer +
          "/register/sedes?tenantId=tenantId" +
          actionStore.methods.getInfoEmpresa().tenantId
      )
      .then(function(response) {
        //console.log(response);
        that.empresas = response.data;
      })
      .then();

    /*
        axios.get(this.url1)
            .then(function (response) {
              //  console.log(response);
                that.perfiles = response.data;
        }).then();

        this.fillTable();*/
  },

  methods: {
    exportarRegistros: function() {
      if (Object.keys(this.empresaSelected).length !== 0) {
        let usuarioSeleccionado = this.selected4 && this.selected4.length > 0 ? this.selected4[0].id : "0";

        this.statusLoader = true;
        let that = this;

        let url =
          actionStore.methods.getInfoEmpresa().urlServer +
          "/register/historicoentradasysalidasexcel/" +
          this.date +
          "/" +
          this.date2 +
          "/" +
          this.empresaSelected.id +
          "/" +
          actionStore.methods.getInfoEmpresa().tenantId +
          "/" +
          usuarioSeleccionado +
          "?tenantId=tenantId" +
          actionStore.methods.getInfoEmpresa().tenantId;
        console.log(url);

        axios
        .post(url, {}, { responseType: 'blob', timeout: 300000 }) // 5 minutes
        .then(function(response) {
          const blob = new Blob([response.data], { type: 'application/zip' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = 'informe-seguimiento.zip';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(link.href);
          that.statusLoader = false;
        })
        .catch(function(error) {
          console.error("Error downloading the file:", error);
          that.statusLoader = false;
          alert("Error al descargar el archivo. Por favor, intenta de nuevo.");
        });
      } else {
        alert("Seleccione una sede primero");
      }
    },

    downloadLInk: function() {
      window.open(
        actionStore.methods.getInfoEmpresa().urlServer +
          "/register/downloadfile/" +
          actionStore.methods.getInfoEmpresa().tenantId +
          "?tenantId=tenantId" +
          actionStore.methods.getInfoEmpresa().tenantId,
        "_blank"
      );
      this.statusLoader = false;
    },

    getRecordSelected: function() {
      this.page3 = 1;
      this.page2 = 1;
      this.page = 1;
      //console.log("USER ID "+this.selected4[0].id);
    },

    getRegistros: function() {
      this.getRegistrosENtradaspaginadas();
      this.getRegistrosSalidaspaginadas();
      this.getTotaltiempoLaborado();
    },

    getRegistrosENtradaspaginadas: function() {
      //this.empresaSelected

      if (Object.keys(this.empresaSelected).length != 0) {
        let usuarioSeleccionado = false;

        if (Object.keys(this.selected4).length == 0) {
          usuarioSeleccionado = "0";
        } else {
          usuarioSeleccionado = this.selected4[0].id;
        }

        let that = this;
        this.url1 =
          actionStore.methods.getInfoEmpresa().urlServer +
          "/register/historicoentradas/" +
          this.page +
          "/" +
          this.date +
          "/" +
          this.date2 +
          "/" +
          this.empresaSelected.id +
          "/" +
          usuarioSeleccionado +
          "?tenantId=tenantId" +
          actionStore.methods.getInfoEmpresa().tenantId;
        let salidas = [];
        let entradas = [];
        axios
          .get(this.url1)
          .then(function(response) {
            that.pageCount = parseInt(response.data.totalPages);
            console.log("total page count " + that.pageCount);
            that.tabla2 = response.data.infoEntradasySalidas;

            /*response.data.infoEntradasySalidas.map(item=>{

                  if(item.tiporegistro=='out'){

                    salidas.push(item);

                  }else{

                    entradas.push(item);
                  }

                })*/

            //that.tabla =salidas;
            //that.tabla2 = entradas;
          })
          .then();

        /*
         this.url1 = actionStore.methods.getInfoEmpresa().urlServer+"/register/historicotiempolaborado/"+this.page3+"/"+this.date+"/"+this.date2+"?tenantId=tenantId"+actionStore.methods.getInfoEmpresa().tenantId;
          axios.get(this.url1)
            .then(function (response) {

              console.log(response);
                
                that.pageCount = parseInt(response.data.totalPages);
                that.tabla3 = response.data.infoTotalTiempolaborado;

          }).then();

        */
      } else {
        alert("seleccione una sede primero");
      }
    },

    getTotaltiempoLaborado: function() {
      if (Object.keys(this.empresaSelected).length != 0) {
        let usuarioSeleccionado = false;

        if (Object.keys(this.selected4).length == 0) {
          usuarioSeleccionado = "0";
        } else {
          usuarioSeleccionado = this.selected4[0].id;
        }

        let that = this;
        this.url1 =
          actionStore.methods.getInfoEmpresa().urlServer +
          "/register/historicotiempolaborado/" +
          this.page3 +
          "/" +
          this.date +
          "/" +
          this.date2 +
          "/" +
          this.empresaSelected.id +
          "/" +
          usuarioSeleccionado +
          "?tenantId=tenantId" +
          actionStore.methods.getInfoEmpresa().tenantId;
        axios
          .get(this.url1)
          .then(function(response) {
            console.log(response);

            that.pageCount3 = parseInt(response.data.totalPages);
            that.tabla3 = response.data.infoTotalTiempolaborado;
          })
          .then();
      }
    },

    getRegistrosSalidaspaginadas: function() {
      if (Object.keys(this.empresaSelected).length != 0) {
        let usuarioSeleccionado = false;

        if (Object.keys(this.selected4).length == 0) {
          usuarioSeleccionado = "0";
        } else {
          usuarioSeleccionado = this.selected4[0].id;
        }

        let that = this;
        this.url1 =
          actionStore.methods.getInfoEmpresa().urlServer +
          "/register/historicosalidas/" +
          this.page2 +
          "/" +
          this.date +
          "/" +
          this.date2 +
          "/" +
          this.empresaSelected.id +
          "/" +
          usuarioSeleccionado +
          "?tenantId=tenantId" +
          actionStore.methods.getInfoEmpresa().tenantId;
        let salidas = [];
        let entradas = [];
        axios
          .get(this.url1)
          .then(function(response) {
            that.pageCount2 = parseInt(response.data.totalPages);
            console.log("total page count " + that.pageCount);
            that.tabla = response.data.infoEntradasySalidas;

            /*response.data.infoEntradasySalidas.map(item=>{

                  if(item.tiporegistro=='out'){

                    salidas.push(item);

                  }else{

                    entradas.push(item);
                  }

                })*/

            //that.tabla =salidas;
            //that.tabla2 = entradas;
          })
          .then();

        /*
         this.url1 = actionStore.methods.getInfoEmpresa().urlServer+"/register/historicotiempolaborado/"+this.page3+"/"+this.date+"/"+this.date2+"?tenantId=tenantId"+actionStore.methods.getInfoEmpresa().tenantId;
          axios.get(this.url1)
            .then(function (response) {

              console.log(response);
                
                that.pageCount = parseInt(response.data.totalPages);
                that.tabla3 = response.data.infoTotalTiempolaborado;

          }).then();

        */
      }
    },

    getPorUsuario: function() {
      this.page3 = 0;
      this.page2 = 0;
      this.page = 0;

      if (this.traeregistrosporusuario) {
        this.singleUsuario = true;
        if (Object.keys(this.empresaSelected).length != 0) {
          this.fillTableUsuarios();
        }
      } else {
        this.selected4 = [];
      }

      /*if(this.radioGroup5==1){

                    this.singleUsuario = true;
                    if(Object.keys(this.empresaSelected).length!=0){

                     // this.fillTableUsuarios();


                    }
                    
                }else{

                  console.log("it has got here ");
                  //this.singleUsuario = false;
                  //this.selected4 = [];
                }*/
    },

    getPorFechahoy: function() {
      if (this.radioGroup4 == 0) {
        this.singleFecha = true;
      } else {
        this.singleFecha = false;
      }
    },

    getEmpresadetails: function() {
      this.empresas.map(item => {
        if (item.id == this.select0) {
          console.log(item);

          this.empresaSelected = item;
          this.fillTableUsuarios();

          //this.getPerfiles();
        }
      });
    },

    getPerfiles: function() {
      let that = this;
      this.url1 =
        actionStore.methods.getInfoEmpresa().urlServer +
        "/register/perfilcargos?tenantId=tenantId" +
        actionStore.methods.getInfoEmpresa().tenantId;
      axios
        .get(this.url1)
        .then(function(response) {
          //  console.log(response);
          that.perfiles = response.data;
        })
        .then();

      this.fillTable();
    },

    fillTableUsuarios: function() {
      let that = this;
      let url =
        actionStore.methods.getInfoEmpresa().urlServer +
        "/register/usuariospaginados/" +
        this.page4 +
        "/" +
        this.empresaSelected.id +
        "?tenantId=tenantId" +
        actionStore.methods.getInfoEmpresa().tenantId;
      console.log("the URL is " + url);
      axios
        .get(url)
        .then(function(response) {
          that.pageCount4 = parseInt(response.data.totalPages);
          that.tabla4 = response.data.infoUsuario;
        })
        .then();
    },

    activateUserAgain() {
      this.dialog = false;
      console.log("the ID  is " + this.cedula);
      let that = this;
      let url =
        actionStore.methods.getInfoEmpresa().urlServer +
        "/register/disableuser/" +
        this.cedula +
        "/1?tenantId=tenantId" +
        that.empresaSelected.tenantId;
      axios
        .post(url, {})
        .then(function(response) {
          that.enablingUser();
        })
        .catch(function(error) {
          console.log("from error..*.");
        });
    },

    enablingUser: function() {
      let url =
        actionStore.methods.getEndpoints().URL_BACKEND +
        "/info/updateuser/" +
        this.cedula +
        "/1";

      let that = this;
      console.log(url);
      axios
        .post(url, {})
        .then(function(response) {
          //console.log("updated user..");
          that.fillTable();
          that.statusLoader = false;
        })
        .catch(function(error) {
          console.log("the error is ");
          console.log(error);
        });
    },

    selectedItems: function() {
      console.log(this.selected);

      let that = this;
      this.selected.map(item => {
        let url =
          actionStore.methods.getInfoEmpresa().urlServer +
          "/register/disableuser/" +
          item.cedula +
          "/0?tenantId=tenantId" +
          that.empresaSelected.tenantId;
        axios
          .post(url, {})
          .then(function(response) {
            that.disablingUser(item.cedula, that);
          })
          .catch(function(error) {
            console.log("from error...");
          });
      });
    },

    disablingUser: function(idSelectedUser, that) {
      let url =
        actionStore.methods.getEndpoints().URL_BACKEND +
        "/info/updateuser/" +
        idSelectedUser +
        "/0";
      axios
        .post(url, {})
        .then(function(response) {
          //console.log("updated user..");
          that.fillTable();
        })
        .catch(function(error) {
          console.log("from error...");
        });
    },

    onPageChange: function() {
      //console.log('page '+this.page);
      this.fillTable();
    },

    fillTable: function() {
      let that = this;
      let url =
        actionStore.methods.getInfoEmpresa().urlServer +
        "/register/usuariospaginados/" +
        this.page +
        "?tenantId=tenantId" +
        actionStore.methods.getInfoEmpresa().tenantId;
      axios
        .get(url)
        .then(function(response) {
          that.pageCount = parseInt(response.data.totalPages);
          that.tabla = response.data.infoUsuario;
        })
        .then();
    },
    hideMessage: function() {
      this.statusEmpty = false;
      this.statusCreated = false;
      this.statusFailure = false;
    },

    getCargo: function() {
      this.hideMessage();
      //console.log('cargo selected..'+this.select2);
    },

    getPerfil: function() {
      this.hideMessage();
      console.log("perfil selected.." + this.select1);
      let url =
        actionStore.methods.getInfoEmpresa().urlServer +
        "/register/cargos/" +
        this.select1 +
        "?tenantId=tenantId" +
        actionStore.methods.getInfoEmpresa().tenantId;
      let that = this;
      axios
        .get(url)
        .then(function(response) {
          console.log(response);
          that.cargoNombre = response.data;
        })
        .then();
    },

    finish: function() {
      if (
        this.select1 != "" &&
        this.select2 != "" &&
        this.nombre != "" &&
        this.cedula != ""
      ) {
        let that = this;
        let responsedata = "";
        let cedula1 = this.cedula;
        let nombre1 = this.nombre;

        this.statusLoader = true;
        let url =
          actionStore.methods.getInfoEmpresa().urlServer +
          "/register/checkuser/" +
          cedula1 +
          "?tenantId=tenantId" +
          actionStore.methods.getInfoEmpresa().tenantId;
        //console.log("URL 1 "+url);
        axios.get(url).then(function(response) {
          //console.log(response);
          if (response.data == "EXISTS") {
            console.log("from exists..");
            let url2 =
              actionStore.methods.getInfoEmpresa().urlServer +
              "/register/checkuserstatus/" +
              cedula1 +
              "?tenantId=tenantId" +
              actionStore.methods.getInfoEmpresa().tenantId;

            axios
              .post(url2, {})
              .then(function(response2) {
                if (response2.data == "EXISTS") {
                  console.log("do you want to reactivate the USER again ?");
                  //that.activateUserAgain(cedula1);
                  that.dialog = true;
                } else {
                  that.statusFailure = true;
                  that.statusLoader = false;
                }
              })
              .catch(function(error) {
                //console.log('from error.*..');
              });
          } else {
            let url =
              actionStore.methods.getInfoEmpresa().urlServer +
              "/register/createuser?tenantId=tenantId" +
              actionStore.methods.getInfoEmpresa().tenantId;
            axios
              .post(url, {
                fkIdPerfil: that.select1,
                fkIdCargo: that.select2,
                cedula: that.cedula,
                nombre: that.nombre.toUpperCase(),
                huella: ""
              })
              .then(function(response) {
                //console.log('from success...');
                //console.log(response);
                //console.log(response.data);
                responsedata = response.data;

                that.creatingUser(
                  responsedata,
                  cedula1,
                  nombre1,
                  actionStore.methods.getInfoEmpresa().urlServer,
                  that
                );

                that.cedula = "";
                that.nombre = "";
              })
              .catch(function(error) {
                console.log("from error...");

                if (error.response.status == 302) {
                  that.statusFailure = true;
                  that.statusLoader = false;
                }
              });
          }
        });
      } else {
        //console.log('campos vacios');
        this.statusEmpty = true;
      }
    },

    creatingUser: function(idUser, cedula, nombre, urlServer, that) {
      console.log("calling from second method");

      let url =
        actionStore.methods.getEndpoints().URL_BACKEND +
        "/api/auth/signup/user";
      axios
        .post(url, {
          name: nombre,
          username: cedula,
          email: cedula + "@none.com",
          password: cedula,

          fkIdTenantDetails: actionStore.methods.getInfoEmpresa().tenantId,
          usuarioTenantId: idUser,
          activo: "si"
        })
        .then(function(response) {
          that.statusCreated = true;
          that.statusLoader = false;

          that.fillTable();
          //console.log('from success...');
          //console.log(response);
        })
        .catch(function(error) {
          console.log(error.message);
          //console.log('from error...2');
          if (error.response.status == 400) {
            that.statusFailure = true;
            that.statusLoader = false;
          }
        });
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${year}-${month}-${day}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
  }
};
</script>

